import type { RouterContext } from "@/libs/@tanstack/react-router/types";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_public")({
	beforeLoad: ({ context }: { context: RouterContext }) => {
		if (context.auth.isAuthenticated) {
			throw redirect({ to: "/recruit-positions" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
